<ng-container *ngIf="!isLoading else showLoader">
    <acabim-datatable
        #subCategoryDataTable
        [dataSources]="dataTableSources"
        [dataKey]="'id'"
        (details)="setSelectedDetails($event)"
        (showDetail)="showDetails($event)"
        [hasDetailView]="true">
    </acabim-datatable>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button (click)="cancel()">Cancel</button>
        <button class="cas-button-action cas-button-right" (click)="add()">Add</button>
    </div>

    <ng-container *ngIf="loadDetails">
        <acabim-modal
            [display]="loadDetails"
            [title]="'Editing: ' + selectedDetails?.name"
            (status)="closeDetailsModal($event)"
            fixHeight="60vh"
            width="60vw">
            <acabim-admin-work-order-subcategory-details
                    [cbiClassOptionsGrouped]="cbiClassOptionsGrouped"
                    [cbiClassOptions]="cbiClassOptions"
                    [workCategoryData]="workCategory"
                    [workSubCategoryData]="selectedDetails"
                    (cancelled)="closeDetailsModal($event)"
                    (completed)="completeDetailsModal($event)"></acabim-admin-work-order-subcategory-details>
        </acabim-modal>
    </ng-container>

    <ng-container *ngIf="addWorkSubCategory">
        <acabim-modal
                [display]="addWorkSubCategory"
                [title]="'Add work sub-category'"
                (status)="closeAddModal($event)"
                fixHeight="60vh"
                width="60vw">
            <acabim-admin-work-order-subcategory-details
                    [cbiClassOptionsGrouped]="cbiClassOptionsGrouped"
                    [cbiClassOptions]="cbiClassOptions"
                    [workCategoryData]="workCategory"
                    [workSubCategoryData]="null"
                    (cancelled)="closeAddModal($event)"
                    (completed)="completeAddModal($event)"></acabim-admin-work-order-subcategory-details>
        </acabim-modal>
    </ng-container>
</ng-container>

<ng-template #showLoader>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
